import React, { Fragment } from 'react';
import Media from 'react-media';
import { HeaderNavItem } from './style';
import Logo from '../../images/opdoLogo';
import { FlexRow, Heading } from '../misc';
import {
  ConnectedHeaderCartItem,
  ConnectedHeaderProfileItem,
  ConnectedNavToggle,
} from '../../containers/header';

const ShopHeader = () => (
  <Fragment>
    <HeaderNavItem>
      <FlexRow>
        <ConnectedNavToggle />
        <Media query="(min-width: 76em)">
          <Heading style={{ color: 'rgba(28,61,90,1)', marginLeft: '8px' }}>
            Menu
          </Heading>
        </Media>
      </FlexRow>
    </HeaderNavItem>
    <HeaderNavItem>
      <Logo width={150} height={63} />
    </HeaderNavItem>
    <FlexRow>
      <ConnectedHeaderCartItem {...this.props} />
      <Media query="(min-width: 64em)">
        {matches => (
          <Fragment>
            {matches && <ConnectedHeaderProfileItem {...this.props} />}
          </Fragment>
        )}
      </Media>
    </FlexRow>
  </Fragment>
);

const CheckoutHeader = () => (
  <Fragment>
    <HeaderNavItem>
      <ConnectedNavToggle />
    </HeaderNavItem>
    <HeaderNavItem>
      <Logo width={150} />
    </HeaderNavItem>
    <HeaderNavItem>
      <div />
    </HeaderNavItem>
  </Fragment>
);

export { ShopHeader, CheckoutHeader };



// WEBPACK FOOTER //
// ../shop_main/components/header/index.js